"use client";

import { useEffect, useState } from "react";

import useQueryAccessibleTools from "../../apis/useQueryAccessibleTools";
import type { ToolTypeEnum } from "../../core/domain/enums/tool-type.enum";

const useToolEnabled = (type: ToolTypeEnum) => {
  const [enabled, setEnabled] = useState<boolean | undefined>(undefined);

  const { data: tools } = useQueryAccessibleTools();

  useEffect(() => {
    if (!tools) {
      return;
    }

    const accessible = Boolean(tools.find(tool => tool.type === type));
    setEnabled(accessible);
  }, [tools, type]);

  return enabled;
};

export default useToolEnabled;
